/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [{
    url: "/",
    name: "Inicio",
    slug: "home",
    icon: "HomeIcon",
  },

  {
    url: "/ordenes",
    name: "Órdenes",
    slug: "ordenes",
    icon: "PackageIcon",
    submenu: [{
        url: '/ordenes/por-enviar',
        slug: 'ordenes-por-enviar',
        name: 'Por Enviar'
      },
      {
        url: '/ordenes/procesadas',
        slug: 'ordenes-procesadas',
        name: 'Procesadas'
      },
      {
        url: '/ordenes/invalidas',
        slug: 'ordenes-invalidas',
        name: 'Inválidas'
      },
      {
        url: '/ordenes/desestimadas',
        slug: 'ordenes-desestimadas',
        name: 'Desestimadas'
      }

    ]
  },
  {
    url: '/conexiones',
    name: 'Conexiónes',
    slug: 'conexiones',
    icon: 'RadioIcon',
  },
  {
    url: '/catalogo',
    name: 'Catálogo',
    slug: 'catalogo',
    icon: 'SlidersIcon',
  },

  /*{
    url: "/cuenta",
    name: "Cuenta",
    slug: "cuenta",
    icon: "SlidersIcon",
  },*/


]
